import React from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import TournamentEventRules from "../../components/Tournament/TournamentEventRules";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";
import {
  useTournamentId,
  useTournamentSlug,
} from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";
import { EVENT_RULES_HEADING } from "../../utility/eventRules";

const TournamentEventRulesPage = () => {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "Tournament", path: tournamentPath(tournamentSlug) },
    { label: EVENT_RULES_HEADING },
  ];

  return (
    <>
      <TournamentSubpageHead page="rules" />
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <div className="card-board overflow-hidden">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            {EVENT_RULES_HEADING}
          </h1>
        </div>
        <div className="p-6">
          <TournamentEventRules
            tournamentId={tournamentId}
            framed={false}
            showHeading={false}
          />
        </div>
      </div>
    </>
  );
};

export default TournamentEventRulesPage;
